export default __webpack_public_path__ + "static/media/lovitos.png.webp";